import { CandidatesConst } from '@axiom/const';
import type { Candidate } from '@axiom/validation';

const { ProfileStatuses } = CandidatesConst;

// Early-pipeline profile statuses: Sales should not be reaching out about this
// talent yet, so the talent owner is hidden from EnvoySales users. See MIE-668.
const OWNER_HIDDEN_FROM_SALES_STATUSES = new Set<string>([
  ProfileStatuses.NewLead,
  ProfileStatuses.Certifying,
  ProfileStatuses.InDiligence,
  ProfileStatuses.Waitlist,
  ProfileStatuses.Reservoir,
]);

export const TalentOwnerUtil = {
  isHiddenFromSales: ({
    isEnvoySalesUser,
    profileStatus,
  }: {
    isEnvoySalesUser: boolean;
    profileStatus: Candidate['profileStatus'];
  }) =>
    isEnvoySalesUser &&
    !!profileStatus &&
    OWNER_HIDDEN_FROM_SALES_STATUSES.has(profileStatus),
};
